import { Injectable } from '@angular/core';
import { OperationType } from '../models/operation-type.enum';
import { InviteDriverOperation } from '../models/operations/invite-driver.operation.model';
import { InviteDispatcherOperation } from '../models/operations/Invite-dispatcher.operation.model';
import { Operation } from '../models/operation.model';
import { OperationPayload } from '../models/operation-payload.model';
import { CreateLeadOperation } from '../models/operations/create-lead.operation.model';

@Injectable()
export class UiOperationFactory {
    getOperation(operationType: OperationType, operationPayload?: OperationPayload) {
        let operation: Operation;
        switch (operationType) {
            case OperationType.InviteDriver:
                operation = new InviteDriverOperation();
                break;
            case OperationType.InviteDispatcher:
                operation = new InviteDispatcherOperation();
                break;
            case OperationType.CreateLead:
                operation = new CreateLeadOperation();
                break;
            default: throw new Error(`There is no type ${OperationType[operationType]} of operation`);
        }

        if (operationPayload && operation.payload) {
            operation.payload = {...operation.payload, ...operationPayload };
        }

        return operation;
    }
}
